import React from 'react';
import { connect } from 'react-redux';
import { Input } from '@progress/kendo-react-inputs';
import { selectPayment } from '../../../../../../Redux/Actions/EndUser/BillingAction';
class ACHPayment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            NameOnAccount: "",
            AccountNumber: "",
            ConfirmAccountNumber: "",
            RoutingNumber: "",
            IsAutoRenew: true,
            PaywithCard: false,
        };
    }

    componentDidMount() {

    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }
    handleCardClick = (event) => {
        this.props.selectPayment("Card")
    }

    isFreeAccount() {
        if (this.props.membership.selectedMembershipType && this.props.membership.selectedMembershipType.description === 'Free Account') {
            return true;
        } else {
            return false;
        }
    }


    handleCheckboxChange = event => {
        this.setState({ checked: event.target.checked })
    }


    render() {
        const confirmAccountValidationMessage = "Account numbers must match!"
        return (
            <div className="paymentContainer">
                <h3 className="main-title mb-2">Enter your <span className="highlight">bank</span> information</h3>
                <div className="fullName-wrapper">
                    <label>Name on Account</label>
                    <Input
                        validityStyles={false}
                        value={this.state.NameOnAccount}
                        onChange={this.handleChange}
                        name="NameOnAccount"
                        // style={{ width: "250px" }}
                        minLength={2}
                        required={this.isFreeAccount() ? false : true}
                    />
                </div>
                <div className="">
                    <div className="accountNumber-wrapper">
                        <label>Account Number</label>
                        <Input
                            validityStyles={false}
                            value={this.state.AccountNumber}
                            onChange={this.handleChange}
                            name="AccountNumber"
                            // style={{ width: "250px" }}
                            required={this.isFreeAccount() ? false : true}
                        />
                    </div>
                    <div className="confirmAccount-wrapper">
                        <label>Confirm Account Number</label>
                        <Input
                            validityStyles={false}
                            valid={this.state.AccountNumber === this.state.ConfirmAccountNumber}
                            validationMessage={confirmAccountValidationMessage}
                            value={this.state.ConfirmAccountNumber}
                            onChange={this.handleChange}
                            name="ConfirmAccountNumber"
                            // style={{ width: "250px" }}
                            minLength={2}
                            required={this.isFreeAccount() ? false : true}
                        />
                    </div>
                    <div className="routingNumber-wrapper">
                        <label>Routing Number</label>
                        <Input
                            validityStyles={false}
                            value={this.state.RoutingNumber}
                            onChange={this.handleChange}
                            name="RoutingNumber"
                            // style={{ width: "250px" }}
                            minLength={2}
                            required={this.isFreeAccount() ? false : true}
                        />
                    </div>
                </div>
                <div className="routingNumber custom-control">
                    {!this.isFreeAccount() ? <div >
                        {/* <label>
                            <input
                                type="checkbox"
                                onChange={this.handleChange}
                                name="IsAutoRenew"
                            />
                            Would you like to set your membership to auto-renew every year
                        </label> */}

                            <input
                                type="checkbox"
                                id="IsAutoRenew"
                                onChange={this.handleChange}
                                name="IsAutoRenew"
                                checked={this.state.checked}
                                onChange={this.handleCheckboxChange}
                            />
                            <label htmlFor="IsAutoRenew">
                                <span className={ this.state.checked ? " far fa-check-square" : "far fa-square"}></span>
                                <span className="custom-control-text">Would you like to set your membership to auto-renew every year</span>
                            </label>

                    </div> : null}
                </div>

                        


                <div className="vertHorzCenter buttonContainer">
                    <button className="signUpBtns mb-3 btnPrimary" onClick={this.backBtnClick}>Back</button>
                    {!this.isFreeAccount() ? <button type="submit" className="signUpBtns mb-3 btnPrimary">NEXT STEP</button> :
                        <button type="submit" className="signUpBtns mb-3 btnPrimary">NEXT STEP</button>}
                        <button className="btnSecondary signUpBtns mb-3" onClick={this.handleCardClick}>Pay With Card</button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        membership: state.membership
    }
}

export default connect(mapStateToProps, { selectPayment })(ACHPayment);

